import * as React from 'react';
import AllowedResizeTypes from '../../store/schema/AllowedResizeTypes';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { SurfaceDraggable } from './SurfaceDraggable';
import {
    SurfaceDragDropConfig,
    SurfaceItem,
    DragOperationType,
    CalendarSurfaceStore,
} from 'owa-calendar-surface-dategrid';

let styles = require('./SurfaceResizeBox.scss');
let classNames = require('classnames/bind').bind(styles);

let selectionStyles = require('owa-calendar-surface-dategrid/lib/logic/SelectionStyles.scss');

/**
 * Props for the surface resize box
 */
export interface SurfaceResizeBoxProps {
    item: SurfaceItem;
    store: CalendarSurfaceStore;
    dragDropConfig: SurfaceDragDropConfig;
    allowedResizeTypes: AllowedResizeTypes;
    colorScheme: ColorScheme;
    children: any;
}

/**
 * The surface resize box attaches resize behavior to calendar items
 */
/**
 * The surface resize box attaches resize behavior to calendar items
 */
export default function SurfaceResizeBox(props: SurfaceResizeBoxProps) {
    const renderResizeBox = () => {
        let { resizeTop, resizeBottom, resizeLeft, resizeRight } = props.allowedResizeTypes;
        return (
            <div className={selectionStyles.resizeBox} key={'resizeBox'}>
                {resizeTop && renderResizeHandle(DragOperationType.ResizeTop, styles.resizeTop)}
                {resizeBottom &&
                    renderResizeHandle(DragOperationType.ResizeBottom, styles.resizeBottom)}
                {resizeLeft && renderResizeHandle(DragOperationType.ResizeLeft, styles.resizeLeft)}
                {resizeRight &&
                    renderResizeHandle(DragOperationType.ResizeRight, styles.resizeRight)}
            </div>
        );
    };
    const renderResizeHandle = (dragType: DragOperationType, dragStyle: any) => {
        let { item, store, dragDropConfig, colorScheme } = props;
        let chicletStyle = { borderColor: colorScheme.calPrimary };
        // Adding a span (resizeChicletWrapper) to handle the position of the top and bottom grippers.
        if (dragDropConfig != null) {
            return (
                <SurfaceDraggable
                    className={classNames(styles.resizeHandle, dragStyle)}
                    item={item}
                    store={store}
                    dragDropConfig={dragDropConfig}
                    dragType={dragType}>
                    <span className={styles.resizeChicletWrapper}>
                        <span className={styles.resizeChiclet} style={chicletStyle} />
                    </span>
                </SurfaceDraggable>
            );
        } else {
            return (
                <div className={classNames(styles.resizeHandle, dragStyle)}>
                    <span className={styles.resizeChicletWrapper}>
                        <span className={styles.resizeChiclet} style={chicletStyle} />
                    </span>
                </div>
            );
        }
    };
    // Inject resize box as sibling into provided element's child nodes collection
    let resizeBox = renderResizeBox();
    return React.cloneElement(props.children, {
        ...{},
        children: [props.children.props.children, resizeBox],
    });
}
